// Adapters Barrel Export
// All default adapters for VNInvestCharts dependency injection
export * from './ResizeAdapter';
export * from './KeyboardAdapter';
export * from './ClockAdapter';
export * from './StorageAdapter';
export * from './PortalAdapter';
export * from './ChartRegistryAdapter';
export * from './BroadcastChannelAdapter';
export * from './WindowEventAdapter';
// NotificationAdapter and AudioAdapter: explicitly export value exports only (types from ChartHandle)
export { createDefaultNotificationAdapter, getDefaultNotificationAdapter, defaultNotificationAdapter, createMockNotificationAdapter, createNoopNotificationAdapter, } from './NotificationAdapter';
export { createDefaultAudioAdapter, getDefaultAudioAdapter, defaultAudioAdapter, createMockAudioAdapter, createNoopAudioAdapter, } from './AudioAdapter';
import { defaultResizeAdapter, defaultKeyboardAdapter, defaultClockAdapter, defaultLocalStorageAdapter, defaultPortalAdapter, defaultChartRegistryAdapter, defaultWindowEventAdapter, defaultNotificationAdapter, defaultAudioAdapter, } from './index';
import { createNoopBroadcastChannelAdapter } from './BroadcastChannelAdapter';
export const defaultAdapters = {
    resizeAdapter: defaultResizeAdapter,
    keyboardAdapter: defaultKeyboardAdapter,
    clockAdapter: defaultClockAdapter,
    storageAdapter: defaultLocalStorageAdapter,
    portalAdapter: defaultPortalAdapter,
    registryAdapter: defaultChartRegistryAdapter,
    broadcastChannelAdapter: createNoopBroadcastChannelAdapter(),
    windowEventAdapter: defaultWindowEventAdapter,
    notificationAdapter: defaultNotificationAdapter,
    audioAdapter: defaultAudioAdapter,
};
export const createAdapterBundle = (overrides = {}) => ({
    ...defaultAdapters,
    ...overrides,
});
// ============================================
// Testing: Virtual Adapters Bundle
// ============================================
import { createVirtualClockAdapter } from './ClockAdapter';
import { createMockPortalAdapter } from './PortalAdapter';
import { createMockChartRegistryAdapter } from './ChartRegistryAdapter';
import { createRefCountedResizeAdapter } from './ResizeAdapter';
import { createMockBroadcastChannelAdapter } from './BroadcastChannelAdapter';
import { createMockWindowEventAdapter } from './WindowEventAdapter';
import { createMockNotificationAdapter } from './NotificationAdapter';
import { createMockAudioAdapter } from './AudioAdapter';
export const createVirtualAdapters = () => ({
    resizeAdapter: createRefCountedResizeAdapter(),
    keyboardAdapter: defaultKeyboardAdapter, // Keyboard harder to virtualize, use real
    clockAdapter: createVirtualClockAdapter(),
    storageAdapter: defaultLocalStorageAdapter, // localStorage works in jsdom
    portalAdapter: createMockPortalAdapter(),
    registryAdapter: createMockChartRegistryAdapter(),
    broadcastChannelAdapter: createMockBroadcastChannelAdapter(),
    windowEventAdapter: createMockWindowEventAdapter(),
    notificationAdapter: createMockNotificationAdapter(),
    audioAdapter: createMockAudioAdapter(),
});
